import api from 'api'

const FETCH_REQUEST = 'realhub/systemManager/invoices/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/systemManager/invoices/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/systemManager/invoices/FETCH_FAILURE'

const UPDATE_INTEGRATION_DATA = 'realhub/systemManager/invoices/UPDATE_INTEGRATION_DATA'

// Initial State
const initialState = {
  integrationData: {},
  loading: false,
  loaded: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    data: payload,
  }
}

export function fetchFailure(payload = {}){
  return {
    type: FETCH_FAILURE,
    data: payload,
  }
}

export function updateIntegrationData(payload = {}){
  return {
    type: UPDATE_INTEGRATION_DATA,
    data: payload,
  }
}

export function updateIntegrationDataWithIntegration(integration = {}){
  return (dispatch, getState) => {
    const {
      systemManager: { invoices: { integrationData } },
    } = getState()

    const { data, id } = integration

    if (integrationData.id === id){
      const updated = {
        ...integrationData,
        data,
      }

      dispatch(updateIntegrationData(updated))
    }
  }
}

export function loadIntegrationData(accountingApi = 'xero'){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/integrations/${accountingApi}/data.json`)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json.integration))
      })
      .catch(() => {
        const data = {}
        dispatch(fetchFailure(data))
      })

    return promise
  }
}

export function disconnectFromIntegration(integrationId){
  const config = {
    method: 'POST',
  }

  return (dispatch) => {
    const promise = api(`/integrations/${integrationId}/disconnect.json`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(updateIntegrationData(json.integration))

        return { success: true, result: json }
      })
      .catch(() => {
        const data = {}
        dispatch(updateIntegrationData(data))

        return { success: false, errors: ['Could not load integration data.'] }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        integrationData: action.data,
        loaded: true,
        loading: false,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        integrationData: action.data,
      }
    case UPDATE_INTEGRATION_DATA:
      return {
        ...state,
        integrationData: action.data,
      }
    default:
      return state
  }
}
